<template>
  <b-navbar toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x">

    <b-navbar-brand to="/">Wine Services Administration</b-navbar-brand>

    <b-collapse is-nav id="app-layout-navbar">
      <b-navbar-nav class="ml-auto align-items-lg-center">
        <!-- Logout Button -->
        <b-nav-item @click="logout" >
          <i>Logout</i>
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
</template>

<script>
import { 
  LOGOUT_REQUEST
} from '../_store/auth/actionTypes';

export default {
  name: 'app-layout-navbar',

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    },

    logout() {
      this.$store.dispatch(LOGOUT_REQUEST, {});
    }
  }
}
</script>
